<template>
  <form @submit.prevent="submitForm">
    <p class="p-4 whitespace-pre-line" v-text="question" />
    <div class="flex justify-center">
      <button class="button button-base warning border border-red-800">
        <font-awesome-icon icon="spinner" spin v-if="loading" fixed-width />
        <font-awesome-icon :icon="icon" v-else fixed-width />
        {{ submit }}
      </button>
    </div>
  </form>
</template>

<script>
import axios from "axios";
import { handleAxiosError } from "@/boot/functions";
export default {
  props: ["question", "icon", "submit", "method", "url"],
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    submitForm() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      axios[this.method](this.url)
        .then(({ data }) => {
          this.$emit("destroyed", data);
        })
        .catch(handleAxiosError)
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
